import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M7 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4ZM3 6a4 4 0 1 1 8 0 4 4 0 0 1-8 0Zm13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3ZM13 8.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0ZM0 18a7 7 0 0 1 12.835-3.869A6.5 6.5 0 0 1 23 19.5V21H0v-3Zm13.998-.18a6.99 6.99 0 0 0-.295-1.845A4.5 4.5 0 0 1 20.973 19H14v-1c0-.06 0-.12-.002-.18ZM12 18c0-.047 0-.094-.002-.141A5 5 0 0 0 2 18v1h10v-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
